module.exports = __webpack_public_path__ + "media/images/site/main_bkg_mobile-856c3a845cb49388c2a92c88efcb7b13.jpg";